import api from './api'

export default class ApiSettings {

    // Получение списка операторов системы
    static async getOperators(): Promise<any> {
        try {
            return await api.get('/setting/getOperators')
        } catch (error) {
            return error
        }
    }

    // Изменение уровня доступа оператора
    static async editAccessLevel(operatorID: string, accessLevelID: string, isChecked: boolean): Promise<any> {
        try {
            return await api.put(`/setting/editAccessLevel?operatorID=${operatorID}&accessLevelID=${accessLevelID}&isChecked=${isChecked}`)
        } catch (error) {
            return error
        }
    }

    // Получение уровней доступа по УМКД
    static async getLevelUmkd(operatorID: number): Promise<any> {
        try {
            return await api.get(`/setting/getLevelUmkd?operatorID=${operatorID}`)
        } catch (error) {
            return error
        }
    }

    // Получение справочника направлений подготовки
    static async getDictDirectionTraining(): Promise<any> {
        try {
            return await api.get(`/setting/getDictDirectionTraining`)
        } catch (error) {
            return error
        }
    }

    // Получение справочника образовательные программы
    static async getDictEducationalProgram(directionTrainingID: number): Promise<any> {
        try {
            return await api.get(`/setting/getDictEducationalProgram?directionTrainingID=${directionTrainingID}`)
        } catch (error) {
            return error
        }
    }

    // Удаление прав доступа для оператора по УМКД
    static async deleteAccessLevelUmkd(operatorID: number, directionTrainingID: number, specializationID: number): Promise<any> {
        try {
            return await api.delete(`/setting/deleteAccessLevelUmkd?operatorID=${operatorID}&directionTrainingID=${directionTrainingID}&specializationID=${specializationID}`)
        } catch (error) {
            return error
        }
    }

    // Назначение прав доступа для оператора по УМКД
    static async addAccessLevelUmkd(operatorID: number, directionTrainingID: number, specializationID: number): Promise<any> {
        try {
            return await api.post(`/setting/addAccessLevelUmkd`, { operatorID, directionTrainingID, specializationID })
        } catch (error) {
            return error
        }
    }
    
    // Получение списка распределенных и не распределенных групп
    static async getGroups(operatorID: number): Promise<any> {
        try {
            return await api.get(`/setting/getGroups?operatorID=${operatorID}`)
        } catch (error) {
            return error
        }
    }

    // Назначение групп оператору (Портфолио студента)
    static async addGroups(operatorID: number, groupNames: any): Promise<any> {
        try {            
            return await api.post(`/setting/addGroups?operatorID=${operatorID}`, {groupNames: groupNames}, { headers: { "Content-Type": "application/json" } })
        } catch (error) {
            return error
        }
    }

    // Удаление групп у оператора (Портфолио студента)
    static async deleteGroups(operatorID: number, groupNames: any): Promise<any> {
        try {
            return await api.delete(`/setting/deleteGroups?operatorID=${operatorID}`, { data: {groupNames: groupNames}, headers: { "Content-Type": "application/json" } })
        } catch (error) {
            return error
        }
    }

    // Добавление оператора
    static async addOperator(operatorData: any): Promise<any> {
        try {
            return await api.post(`/setting/addOperator`, { operatorData: operatorData, headers: { "Content-Type": "application/json" } })
        } catch (error) {
            return error
        }
    }

    // Изменение данных оператора
    static async updateOperatorData(operatorID: number, fieldType: string, fieldValue: string, operatorFIO: any): Promise<any> {
        try {
            return await api.put(`/setting/updateOperatorData?operatorID=${operatorID}&fieldType=${fieldType}&fieldValue=${fieldValue}`, { operatorFIO: operatorFIO, headers: { "Content-Type": "application/json" } })
        } catch (error) {
            return error
        }
    }
}